import {
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ListContent from "./ListContent";
import ListToolbar from "../elements/table/ListToolbar";
import ListHead from "../elements/table/ListHead";
import Loading from "../Loading/loading";

export default function CategoryListTable({
  filteredData,
  fetchData,
  addModal,
  columnFields,
  tableName,
  setMessage,
  setSnackbarOpen,
  page,
  pageSize,
  loading,
  searchTerm,
  handleSearch,
}) {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");

  const handleRequestSort = (property) => {
    if (property === "name") {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    }
  };

  const noCategoriesAdded = !filteredData.length && !searchTerm;
  const isNotFound = !filteredData.length && !!searchTerm;
  const cumulativeProductCount = page * pageSize;

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          {tableName}
        </Typography>
        {addModal}
      </Stack>

      <Card>
        <ListToolbar filterName={searchTerm} onFilterName={handleSearch} />

        <TableContainer sx={{ minWidth: 600 }}>
          {loading ? (
            <Loading />
          ) : (
            <Table>
              <ListHead
                order={order}
                orderBy={orderBy}
                headLabel={columnFields}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredData.map((row, index) => (
                  <ListContent
                    key={row.id}
                    row={row}
                    columns={columnFields}
                    index={cumulativeProductCount + index}
                    fetchData={fetchData}
                    tableName={tableName}
                    setMessage={setMessage}
                    setSnackbarOpen={setSnackbarOpen}
                  />
                ))}
              </TableBody>
              {noCategoriesAdded && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={7}
                      sx={{ py: 3, textAlign: 'center' }}>
                      <Typography variant="body2">
                        No categories have been added yet
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={7}
                      sx={{ py: 3, textAlign: 'center' }}>
                      <Typography variant="body2">
                        No matching categories found
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          )}
        </TableContainer>
      </Card>
    </>
  );
}
